// @ts-nocheck
import { useCompatQuery, useCompatMutation } from './useApolloCompat';
import {
  REQUESTS_QUERY,
  CREATE_REQUEST_MUTATION,
  APPROVE_REQUEST_MUTATION,
  DENY_REQUEST_MUTATION,
} from '../graphql/operations';

export function useRequests(variables?: { page?: number; perPage?: number; status?: string }) {
  return useCompatQuery(REQUESTS_QUERY, { variables, notifyOnNetworkStatusChange: true });
}

export function useCreateRequest() {
  return useCompatMutation(CREATE_REQUEST_MUTATION, {
    refetchQueries: [{ query: REQUESTS_QUERY }],
  });
}

export function useApproveRequest() {
  return useCompatMutation(APPROVE_REQUEST_MUTATION, {
    refetchQueries: [{ query: REQUESTS_QUERY }],
  });
}

export function useDenyRequest() {
  return useCompatMutation(DENY_REQUEST_MUTATION, {
    refetchQueries: [{ query: REQUESTS_QUERY }],
  });
}
